export enum ForgotPasswordStep {
  InputPhoneNumber,
  InputOtpCode,
  InputNewPassword,
}
